import styled from "styled-components";

import { options } from "./styles-options";
import { TEMPLATES_CUSTOM_WIDTH } from "./defaults";

export const TemplatesCollapsibleContainer = styled.div`
  position: relative;
  width: ${({ isCollapsed, macro }) => {
    if (isCollapsed) return "30px";
    if (TEMPLATES_CUSTOM_WIDTH.includes(macro)) return options.width[macro];
    if (!TEMPLATES_CUSTOM_WIDTH.includes(macro)) return options.width.default;
  }};
  border-right: 1px solid ${({ theme }) => theme.border.black10};
  z-index: 20;
  background-color: ${({ isCollapsed, theme }) =>
    isCollapsed ? theme.bg.secondary : theme.bg.general};
  box-sizing: border-box;
  flex-shrink: 0;
  transition: 150ms;

  ${({ isCollapsed, hasTemplates, theme }) =>
    isCollapsed && hasTemplates
      ? `
        &:hover {
          background-color: ${theme.bg.general};
          box-shadow: 4px 0 25px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;
        }
      `
      : `box-shadow: 4px 0 10px 0 rgba(0, 0, 0, 0.04);`}
`;

export const TemplatesContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: ${({ isCollapsed }) => (isCollapsed ? "0" : "48px 24px")};
  box-sizing: border-box;
  height: 100%;
`;

export const AnimationContainer = styled.div`
  opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
  transition: opacity 0ms ${({ isCollapsed }) => (isCollapsed ? 0 : "150ms")};
`;

export const TemplatesContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TemplatesContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-family: "PP Formula";
  }
`;

export const TemplatesTabsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: ${({ theme }) => theme.bg.primary};
  border: 1px solid ${({ theme }) => theme.border.black10};
  border-radius: 8px;
  padding: 4px;
`;

export const TemplatesTab = styled.button`
  display: grid;
  place-content: center;
  padding: 8px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.text.title : "transparent"};
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.text.inverse : theme.text.text};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
`;

export const TemplatesActionButton = styled.button`
  position: absolute;
  background: ${({ theme }) => theme.text.inverse};
  box-shadow: 0px 0px 4.193px 0px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  font-size: 10px;
  border: 1px solid ${({ theme }) => theme.border.black10};
  border-radius: 9999px;
  cursor: pointer;
  transform: rotate(-90deg);
  white-space: nowrap;
  padding: 5px 8px 3px;
  right: -37px;
  top: 105px;
  font-family: "PP Formula";
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const MacroTemplateContainer = styled.div`
  background-color: ${({ isSelected, theme }) =>
    theme.bg[isSelected ? "primary" : "secondary"]};
  border: ${({ isSelected }) =>
    `1px solid ${isSelected ? "#fff" : "rgba(0, 0, 0, 0.15)"}`};
  position: relative;

  .remove-from-library {
    visibility: hidden;
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `
        outline-offset: 3px;
        outline: 6px solid ${theme.border.brand}4d;
    `}

  &:hover {
    outline-offset: 3px;
    outline: 6px solid ${({ theme }) => theme.border.brand}4d;
    background-color: ${({ theme }) => theme.bg.primary};

    .remove-from-library {
      visibility: visible;
    }
  }
`;

export const OverviewMacroTemplateContainer = styled.div`
  background-color: ${({ theme }) => theme.bg.secondary};
  border: 1px solid ${({ theme }) => theme.border.black15};
  position: relative;

  &:hover {
    outline-offset: 3px;
    outline: 6px solid ${({ theme }) => theme.border.brand}4d;
    background-color: ${({ theme }) => theme.bg.primary};
  }
`;

export const ModalContent = styled.div`
  border-radius: 12px;
  background: ${({ theme }) => (theme.name === "dark" ? "#2f2f2f" : "#fff")};
  box-shadow: 0 0 1px 0 rgba(9, 30, 66, 0.31),
    0 8px 12px 0 rgba(9, 30, 66, 0.15);
  position: relative;
  padding: 20px;
`;

export const ModalHeader = styled.div`
  font-size: 20px;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.text.title};
`;

export const ModalDescription = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.text.title};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
`;
